/** Shared value types for the pure game core. No three.js in this folder. */

/** A maze cell, in grid coordinates. `x` runs east, `y` runs south. */
export interface Tile {
  readonly x: number;
  readonly y: number;
}

/** A continuous position in grid space; `(1.5, 2)` is the centre of tile (1,2)'s east edge. */
export interface Vec2 {
  readonly x: number;
  readonly y: number;
}

export const DIRECTIONS = ["up", "left", "down", "right"] as const;
export type Direction = (typeof DIRECTIONS)[number];

/** What a maze cell contains. */
export type CellKind =
  | "wall"
  | "corridor"
  | "storyPoint"
  | "quotaReset" // the power pellet: a 5h Quota Reset that makes AI Slop flee
  | "door" // the slop-den gate: passable by slop, never by the player
  | "den"; // interior of the slop den

export type GhostName = "blinky" | "pinky" | "inky" | "clyde";

/** Global ghost behaviour phase. `eaten` is per-ghost and lives on the ghost itself. */
export type GhostMode = "scatter" | "chase" | "frightened";

export type GhostState = "house" | "leaving" | "hunting" | "eaten";

export type GameStatus = "ready" | "playing" | "dying" | "levelComplete" | "gameOver";
